import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import AppMinimal from './AppMinimal.tsx'
import AppSuperMinimal from './AppSuperMinimal.tsx'
import AppWithRouter from './AppWithRouter.tsx'
import './index.css'
import './utils/TimerFix.ts' // Auto-apply timer fixes
import { initSentry } from './lib/sentry'
import './lib/debugLogger' // Debug logger for API call tracking

// Initialize Sentry for error tracking
initSentry();

// Use the main App component with proper routing
createRoot(document.getElementById("root")!).render(<App />);
